import SectionHead from "./SectionHead";
import { leaks } from "@/mocks/social";

const tone: Record<string, string> = {
  hot: "bg-primary-100 text-primary-700",
  mid: "bg-accent-100 text-accent-800",
  cool: "bg-secondary-200 text-secondary-700",
};

export default function ProgressGrid() {
  return (
    <section id="progress" className="scroll-mt-24 bg-background-100">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-10 md:px-6 md:py-16">
        <SectionHead
          no="04"
          kicker="最新进展 · 后续爆料"
          title="短讯速递 · 追更不停更"
          sub="各专题在追事件的高频短讯并行滚动，按最近更新时间排列，口径存疑处均有标注。"
          right={
            <span className="inline-flex items-center gap-2 text-xs font-semibold text-primary-600">
              <i className="ri-loader-4-line animate-spin text-sm" />
              已同步 · 刚刚
            </span>
          }
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-5 lg:grid-cols-4">
          {leaks.map((l) => (
            <article
              key={l.title}
              className="group flex h-full flex-col rounded-lg border border-secondary-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
            >
              <div className="mb-2.5 flex items-center justify-between gap-2">
                <span className="inline-flex items-center gap-1.5 text-xs font-bold text-foreground-900">
                  <i className="ri-flag-2-fill text-primary-500" />
                  {l.event}
                </span>
                <span className={`whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-semibold ${tone[l.tone]}`}>
                  {l.tag}
                </span>
              </div>
              <h4 className="line-clamp-3 text-sm font-medium leading-6 text-foreground-800 md:text-[15px] md:leading-7">
                {l.title}
              </h4>
              <div className="mt-auto flex items-center justify-between pt-4 text-[11px] text-secondary-500">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-time-line" />
                  {l.time}
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-eye-line" />
                  {l.views}
                </span>
                <a
                  href="#track"
                  className="flex h-6 w-6 items-center justify-center rounded-full border border-secondary-200 text-foreground-700 transition-colors group-hover:border-primary-400 group-hover:text-primary-600"
                  aria-label="查看"
                >
                  <i className="ri-arrow-right-up-line text-xs" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}